import styled from 'styled-components';

export const CardsContainerDesktop = styled.div<{
	hasOneCarline: boolean;
}>`
	display: flex;
	flex-direction: column;
	gap: ${(props) => props.theme.size.static200};

	max-width: 100%;

	// Tablet size
	@media screen and (min-width: 960px) and (max-width: 1199px) {
		// Cards en horizontal
		flex-direction: row;
		align-items: start;
		padding: ${(props) => props.hasOneCarline && '0 30px'};
	}

	@media screen and (max-width: 1199px) {
		padding-bottom: ${(props) => props.hasOneCarline && 'var(--size-dynamic0120)'};
		& > div {
			scroll-snap-align: center;
		}
	}

	::-webkit-scrollbar {
		display: none; /* for Chrome, Safari and Opera */
		scrollbar-width: none; /* Firefox */
	}
`;
